import gql from 'graphql-tag';

export const UPDATE_ACKNOWLEDGEMENT = gql`
  mutation updateAcknowledgement($inputs: UpdateAcknowledgementInput!) {
    updateAcknowledgement(inputs: $inputs) {
      id
    }
  }
`;
